import React from "react";

// Fondo de video reutilizable para las secciones.
// Autoplay silencioso + loop, con poster mientras carga el video
// y un overlay oscuro para que el contenido siga siendo legible.
const VideoBackground = ({
  src,
  poster,
  fixed = false,
  overlayClass = "bg-[#0E0B09]/70",
}) => {
  const position = fixed ? "fixed" : "absolute";

  return (
    <>
      <video
        src={src}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        className={`${position} inset-0 w-full h-full object-cover`}
      />
      <div className={`${position} inset-0 ${overlayClass}`} />
    </>
  );
};

export default VideoBackground;